import {
  DeleteSystemGroupRequest,
  DeleteSystemGroupRequestToJSON,
  HTTPBody,
  RegisterSystemGroupRequest,
  RegisterSystemGroupRequestToJSON,
  SystemGroup,
  SystemGroupFromJSON,
  UpdateSystemGroupRequest,
  UpdateSystemGroupRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class SystemGroupApi extends runtime.BaseAPI {
  /**
   * システムグループの一覧を取得する
   * システムグループ一覧取得
   */
  async getSystemGroups(): Promise<SystemGroup[]> {
    const response = await this.requestGet(`/system-groups`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemGroupFromJSON)
    ).value()
  }

  /**
   * システムグループを取得する
   * システムグループ取得
   */
  async getSystemGroup(id: string): Promise<SystemGroup> {
    const response = await this.requestGet(`/system-groups/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemGroupFromJSON(jsonValue)
    ).value()
  }

  /**
   * システムグループを登録する
   * システムグループ登録
   */
  async registerSystemGroup(
    request: RegisterSystemGroupRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterSystemGroupRequestToJSON(request)

    const response = await this.requestPost('/system-groups', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * システムグループを更新する
   * システムグループ更新
   */
  async updateSystemGroup(
    request: UpdateSystemGroupRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateSystemGroupRequestToJSON(request)

    const response = await this.requestPut(
      `/system-groups/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * システムグループを削除する
   * システムグループ削除
   */
  async deleteSystemGroup(
    request: DeleteSystemGroupRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteSystemGroupRequestToJSON(request)

    const response = await this.requestDelete(
      `/system-groups/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
